export default __webpack_public_path__ + "static/media/telefy-dark1.ffdeea9a.svg";